"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerEvents = exports.PlayerEventKind = void 0;
const nanoid_1 = require("nanoid");
const PlayerEntity_1 = require("../../data/PlayerEntity");
var PlayerEventKind;
(function (PlayerEventKind) {
    PlayerEventKind["Created"] = "poker:player:created";
    PlayerEventKind["BeganPlay"] = "poker:player:began_play";
    PlayerEventKind["Fold"] = "poker:player:folded";
    PlayerEventKind["AllIn"] = "poker:player:allin";
    PlayerEventKind["SitOut"] = "poker:player:sitout";
    PlayerEventKind["ForeverOut"] = "poker:player:foreverout";
    PlayerEventKind["Waiting"] = "poker:player:waiting";
    PlayerEventKind["Disconnected"] = "poker:player:disconnected";
    PlayerEventKind["PaidBet"] = "poker:player:paid_bet";
    PlayerEventKind["ReceivedCards"] = "poker:player:received_cards";
    PlayerEventKind["ReturnedCards"] = "poker:player:returned_cards";
    PlayerEventKind["BuyIn"] = "poker:player:buyin";
    PlayerEventKind["DoNoAction"] = "poker:player:donoaction";
    PlayerEventKind["Observer"] = "poker:player:observer";
})(PlayerEventKind || (PlayerEventKind = {}));
exports.PlayerEventKind = PlayerEventKind;
class PlayerEvents {
    static created(player) {
        return PlayerEvents.createEvent(PlayerEventKind.Created, player);
    }
    static beganPlay(player) {
        return PlayerEvents.createEvent(PlayerEventKind.BeganPlay, player);
    }
    static fold(player) {
        return PlayerEvents.createEvent(PlayerEventKind.Fold, player);
    }
    static allin(player) {
        return PlayerEvents.createEvent(PlayerEventKind.AllIn, player);
    }
    static sitout(player) {
        return PlayerEvents.createEvent(PlayerEventKind.SitOut, player);
    }
    static foreverOut(player) {
        return PlayerEvents.createEvent(PlayerEventKind.ForeverOut, player);
    }
    static waiting(player) {
        return PlayerEvents.createEvent(PlayerEventKind.Waiting, player);
    }
    static observer(player) {
        return PlayerEvents.createEvent(PlayerEventKind.Observer, player);
    }
    static disconnected(player) {
        return PlayerEvents.createEvent(PlayerEventKind.Disconnected, player);
    }
    static paidBet(player) {
        return PlayerEvents.createEvent(PlayerEventKind.PaidBet, player);
    }
    static receivedCards(player) {
        return PlayerEvents.createEvent(PlayerEventKind.ReceivedCards, player);
    }
    static returnedCards(player) {
        return PlayerEvents.createEvent(PlayerEventKind.ReturnedCards, player);
    }
    static buyChips(player) {
        return PlayerEvents.createEvent(PlayerEventKind.BuyIn, player);
    }
    static doNoAction(player) {
        return PlayerEvents.createEvent(PlayerEventKind.DoNoAction, player);
    }
    static createEvent(eventKind, player) {
        return {
            id: nanoid_1.nanoid(),
            name: eventKind,
            timestamp: Date.now(),
            kind: eventKind,
            player: PlayerEntity_1.PlayerEntity.createFromPlayer(player),
        };
    }
}
exports.PlayerEvents = PlayerEvents;
//# sourceMappingURL=PlayerEvent.js.map